export const routes = [
  {
    path: '/',
    name: 'home'
  },
  {
    path: '/:locale/' ,
    props: true,
    component: () => import('@/App'),
    children: [
      {
        path: '/',
        name: 'list',
        props: {
          default: true,
          navigation: true
        },
        components: {
          default: () => import('@/pages/Home'),
        }
      }
    ]
  }
]

export default routes